export default __webpack_public_path__ + "static/media/Termo de Uso - Muron.5ab5546c.pdf";